export const defaultHeaderTitles = [
    {
        "name": "c0",
        "width": 180,
        "align": "center"
    },
    {
        "name": "c1",
        "width": 410,
        "align": "center"
    },
    {
        "name": "c2",
        "width": 140,
        "align": "center"
    }
]